import type { FunctionComponent } from 'react'
import React, { useContext, useRef, useState } from 'react'

import { TextAreaPage } from '../../../../shared/pages/TextAreaPage'
import { ToolContext } from '../../../../shared/state/appContext'
import type { FormEntryTextAreaRef } from '../../../../shared/types/toolTypes'
import { formatToolName } from '../../../../shared/utils/formatToolName'
import { getCleanValue } from '../../../../shared/utils/getCleanValue'
import { isNotEmpty } from '../../../../shared/utils/isNotEmpty'
import { generalDataLayer } from '../../../../shared/utils/tracking'
import { validateCharCount } from '../../../../shared/utils/validateCharCount'
import { ContactDetailsFlow, IssueDescriptionFlow } from '../../pageFlowData'
import { whatHappenedData } from './data'

export const WhatHappened: FunctionComponent = () => {
  const { imgObj, title, placeholderText, descriptiveText, note } = whatHappenedData
  const { state, dispatch } = useContext(ToolContext)
  const {
    initial: { entryToolName },
  } = state

  const [WhatHappenedTextAreaValid, setWhatHappenedTextAreaValid] = useState<boolean>(true)

  const WhatHappenedTextAreaRef = useRef<FormEntryTextAreaRef>(null)

  const handleWhatHappenedChange = () => {
    const value = getCleanValue(WhatHappenedTextAreaRef.current?.formEntryTextarea?.value)

    const isValid: boolean = validateCharCount(value.length, 2500)
    const fieldNotEmpty: boolean = isNotEmpty(value)
    if (fieldNotEmpty && isValid) {
      setWhatHappenedTextAreaValid(true)
    }
  }

  const handleDispatch = (value: string) => {
    dispatch({ type: 'UPDATE_ISSUE_DESCRIPTION', data: value })
    dispatch({ type: 'UPDATE_STEP', data: ContactDetailsFlow.STEP })
    dispatch({ type: 'UPDATE_PROGRESS_VALUE', data: ContactDetailsFlow.PROGRESS_VALUE })
  }

  const handleTracking = () => {
    const trackingAnswer = `question | ${IssueDescriptionFlow.VIEW_NAME} | PII`
    generalDataLayer(formatToolName(entryToolName), trackingAnswer, false)
  }

  const handleWhatHappenedSubmit = () => {
    const value: string = getCleanValue(WhatHappenedTextAreaRef.current?.formEntryTextarea?.value)
    const isValid: boolean = validateCharCount(value.length, 2500)
    const isEmpty = !isNotEmpty(value)

    if (!isValid || isEmpty) {
      setWhatHappenedTextAreaValid(false)
      return
    }

    setWhatHappenedTextAreaValid(true)
    handleTracking()
    handleDispatch(value)
  }

  return (
    <div data-testid="what-happened">
      <TextAreaPage
        buttonText="Next"
        defaultValue=""
        descriptiveText={descriptiveText}
        handleChange={handleWhatHappenedChange}
        handleSubmit={handleWhatHappenedSubmit}
        imgObj={imgObj}
        isFocused
        isInputValid={WhatHappenedTextAreaValid}
        maxChars={2500}
        noteTop={note}
        placeholderText={placeholderText}
        ref={WhatHappenedTextAreaRef}
        title={title}
      />
    </div>
  )
}
